import CarouselController from "./carousel-controller";
import { ProductCard } from "../components";
export default class extends CarouselController {
  static targets = ["slides", "loader", "carousel"];
  static values = { product: String };
  initialize() {
    if (this.productValue) {
      this.handleProductArray();
    } else {
      this.loaderTarget.remove();
      this.carouselTarget.classList.remove("hidden");
      this.handleMount();
    }
  }

  async fetchRecommendedProducts() {
    const res = await fetch(
      `/recommendations/products.json?product_id=${this.productValue}&limit=8`
    );

    const data = await res.json();

    return data?.products || null;
  }

  async fetchProductData(handle) {
    const res = await fetch(`/products/${handle}?view=json`);
    const data = await res.json();
    return data;
  }

  async handleProductArray() {
    const products = await this.fetchRecommendedProducts();

    const config = {
      perPage: Math.min(products.length, 8),
      width: 300 * products.length,
      padding: { left: 12, right: products.length > 8 ? 96 : 12 },
      gap: 12,
      type: "loop",
      arrows: products.length > 8,
      perMove: 1,
      breakpoints: {
        480: {
          perPage: Math.min(products.length, 1),
          arrows: products.length > 1,
          padding: { left: 12, right: products.length > 1 ? 32 : 12 },
        },
        880: {
          perPage: Math.min(products.length, 2),
          arrows: products.length > 2,
        },
        1280: {
          perPage: Math.min(products.length, 4),
          arrows: products.length > 4,
          padding: { left: 12, right: products.length > 4 ? 64 : 12 },
        },
        1920: {
          perPage: Math.min(products.length, 6),
          arrows: products.length > 6,
        },
      },
    };

    for await (const product of products) {
      const data = await this.fetchProductData(product.handle);

      this.slidesTarget.innerHTML += `
        <li class="splide__slide">
          ${ProductCard(data, data.product.variants[0].id, true)}
        </li>
      `;
    }

    this.loaderTarget.remove();
    this.carouselTarget.classList.remove("hidden");
    this.carouselTarget.setAttribute("data-splide", JSON.stringify(config));
    this.handleMount();
  }

  handleError(error) {
    console.error("There was an error fetching the product", error);
  }
}
